module.exports = __webpack_public_path__ + "img/crm02.4e684ee9.jpg";